export default "__VITE_ASSET__BCQ8yH36__"